var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import { store } from './FirebaseProvider';
export var useFirebase = function () {
    var _a = React.useContext(store), instance = _a.instance, uiConfig = _a.uiConfig;
    var addOrUpdateSettings = function (_a) {
        var _id = _a._id, data = _a.data;
        if (data.deleted === undefined)
            data.deleted = false;
        console.log("%c Update settings", 'background: blue; color: white');
        return instance === null || instance === void 0 ? void 0 : instance.settings.doc(_id).set(data, { merge: true });
    };
    var addOrUpdatePage = function (_a) {
        var _id = _a._id, data = _a.data;
        if (data.deleted === undefined)
            data.deleted = false;
        console.log("%c Update page " + _id, 'background: blue; color: white');
        return instance === null || instance === void 0 ? void 0 : instance.pages.doc(_id).set(data, { merge: true });
    };
    var deletePage = function (_a) {
        var _id = _a._id;
        return instance === null || instance === void 0 ? void 0 : instance.pages.doc(_id).set({ deleted: 1 }, { merge: true });
    };
    var addOrUpdateBlock = function (_a) {
        var _id = _a._id, data = _a.data;
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (data.deleted === undefined)
                    data.deleted = false;
                console.log("%c Update box " + _id, 'background: blue; color: white');
                if (data.backgroundImage && typeof data.backgroundImage === 'object') {
                    return [2, instance === null || instance === void 0 ? void 0 : instance.blockDrive.child(_id + "/main").put(data.backgroundImage).then(function (snapshot) {
                            snapshot.ref.getDownloadURL()
                                .then(function (backgroundImage) {
                                instance === null || instance === void 0 ? void 0 : instance.blocks.doc(_id).set(__assign(__assign({}, data), { backgroundImage: backgroundImage }), { merge: true });
                            })
                                .catch(function (savingError) {
                                console.error('getDownloadURL failed:', savingError);
                                instance === null || instance === void 0 ? void 0 : instance.blocks.doc(_id).set(__assign(__assign({}, data), { backgroundImage: "" }), { merge: true });
                            });
                        }).catch(function (savingError) {
                            console.error('Upload failed:', savingError);
                            instance === null || instance === void 0 ? void 0 : instance.blocks.doc(_id).set(__assign(__assign({}, data), { backgroundImage: "" }), { merge: true });
                        })];
                }
                else {
                    return [2, instance === null || instance === void 0 ? void 0 : instance.blocks.doc(_id).set(data, { merge: true })];
                }
                return [2];
            });
        });
    };
    var deleteBlock = function (_a) {
        var _id = _a._id;
        return instance === null || instance === void 0 ? void 0 : instance.blocks.doc(_id).set({ deleted: 1 }, { merge: true });
    };
    var onAuthStateChanged = function (callback) {
        return instance === null || instance === void 0 ? void 0 : instance.auth.onAuthStateChanged(callback);
    };
    var passwordReset = function (email) {
        var actionCodeSettings = {
            url: "./",
            handleCodeInApp: true,
        };
        return instance === null || instance === void 0 ? void 0 : instance.auth.sendPasswordResetEmail(email, actionCodeSettings);
    };
    var passwordUpdate = function (password) { var _a; return (_a = instance === null || instance === void 0 ? void 0 : instance.auth.currentUser) === null || _a === void 0 ? void 0 : _a.updatePassword(password); };
    var sendVerificationEmail = function () {
        var _a;
        var actionCodeSettings = {
            url: "./",
            handleCodeInApp: true,
        };
        return (_a = instance === null || instance === void 0 ? void 0 : instance.auth.currentUser) === null || _a === void 0 ? void 0 : _a.sendEmailVerification(actionCodeSettings);
    };
    var signOut = function () {
        return instance === null || instance === void 0 ? void 0 : instance.auth.signOut();
    };
    return {
        firebase: firebase,
        instance: instance,
        uiConfig: uiConfig,
        signOut: signOut,
        sendVerificationEmail: sendVerificationEmail,
        passwordUpdate: passwordUpdate,
        passwordReset: passwordReset,
        onAuthStateChanged: onAuthStateChanged,
        deleteBlock: deleteBlock,
        deletePage: deletePage,
        addOrUpdateSettings: addOrUpdateSettings,
        addOrUpdateBlock: addOrUpdateBlock,
        addOrUpdatePage: addOrUpdatePage
    };
};
